import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    drm: null,
    fetchingDrm: false,
    creatingDrm: false,
    updatingDrm: false,
    noDrm: false,
  },
  mutations: {
    SET_DRM(state, value) {
      state.drm = value
    },
    SET_FETCHING_DRM(state, value) {
      state.fetchingDrm = value
    },
    SET_CREATING_DRM(state, value) {
      state.creatingDrm = value
    },
    SET_UPDATING_DRM(state, value) {
      state.updatingDrm = value
    },
    SET_NO_DRM(state, value) {
      state.noDrm = value
    },
    RESET_DRM(state) {
      state.drm = null
      state.noDrm = null
    },
  },
  actions: {
    getDrm({ commit }) {
      commit('RESET_DRM')
      commit('SET_FETCHING_DRM', true)
      return new Promise((resolve, reject) => {
        api('encoder').get(`projects/${getProjectId()}/drm`)
          .then(response => {
            commit('SET_DRM', response.data.result)
            commit('SET_NO_DRM', false)
            resolve(response)
          })
          .catch(error => {
            if (error.response.status === 424) {
              commit('SET_NO_DRM', true)
            }
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_DRM', false) })
      })
    },
    createDrm({ commit }, payload) {
      commit('SET_CREATING_DRM', true)
      return new Promise((resolve, reject) => {
        api('encoder').post(`projects/${getProjectId()}/drm`, payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_CREATING_DRM', false) })
      })
    },
    updateDrm({ commit }, payload) {
      commit('SET_UPDATING_DRM', true)
      return new Promise((resolve, reject) => {
        api('encoder').put(`projects/${getProjectId()}/drm`, payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_UPDATING_DRM', false) })
      })
    },
    resetDrm({ commit }) {
      commit('RESET_DRM')
    },
  },
}
